export const generateRemoteUrl = (fromDate?: string, toDate?: string, searchQuery?: string) => {
  const params = new URLSearchParams();

  if (fromDate) {
    params.append("from", fromDate);
  }
  if (toDate) {
    params.append("to", toDate);
  }
  if (searchQuery) {
    params.append("search", searchQuery);
  }

  return `documents/diplomas${params.toString() ? `?${params.toString()}` : ""}`;
};
